import { createSliderWidget } from "../../widgets/slider.js";
import { EVENTS_SLIDER_QUERY } from "../../strategies/fetch/events.js";
const eventsSlider = (props) => createSliderWidget({
  ...props,
  query: EVENTS_SLIDER_QUERY,
  url: "https://calendar.umd.edu/graphql"
});
export {
  eventsSlider
};
//# sourceMappingURL=slider.js.map
